export const GENDER_OPTIONS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

export const YES_NO_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const CATEGORY_OPTIONS = [
  { value: "Single", label: "Single" },
  { value: "Double", label: "Double" },
];

export const CRUISE_OPTIONS = [
  {
    value:
      "Interior Stateroom (no window, occupancy up to 4 guests) - Standard",
    label:
      "Interior Stateroom (no window, occupancy up to 4 guests) - Standard",
  },
  {
    value: "Ocean View Stateroom (window, occupancy up to 4 guests)",
    label: "Ocean View Stateroom (window, occupancy up to 4 guests)",
  },
  {
    value: "Balcony Stateroom (occupancy up to 2 guests) - Upgrade",
    label: "Balcony Stateroom (occupancy up to 2 guests) - Upgrade",
  },
];

export const CONFERENCE_OPTIONS = [
  {
    value: "Southern New England Conference",
    label: "Southern New England Conference",
  },
  { value: "Mountain View Conference", label: "Mountain View Conference" },
  { value: "Other", label: "Other" },
];

export const TSHIRT_OPTIONS = [
  { value: "xs", label: "XS" },
  { value: "s", label: "S" },
  { value: "m", label: "M" },
  { value: "l", label: "L" },
  { value: "xl", label: "XL" },
  { value: "xxl", label: "XXL" },
];

export function shiftDisableRules(rules, startIndex) {
  const offset = startIndex - 1;
  const shifted = {};

  Object.keys(rules).forEach((key) => {
    const newKey = Number(key) + offset;
    shifted[newKey] = rules[key].map((v) => v + offset);
  });

  return shifted;
}

export const BASE_DISABLE_RULES = {
  1: [2, 4, 6, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
  2: [
    1, 3, 5, 7, 9, 11, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26,
  ],
  3: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
  4: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
  5: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
  6: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
  7: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
  8: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
  9: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
  10: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
  11: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
  12: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],

  13: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16],
  14: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15, 16, 17, 19, 21, 23, 25],
  15: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 16],
  16: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 17, 19, 21, 23, 25],
  17: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  18: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  19: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  20: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  21: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  22: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  23: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  24: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  25: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  26: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
};
